export default __webpack_public_path__ + "static/media/download.28665361.svg";